module.exports = process.env.PROMISE_QUEUE_COVERAGE ?
    require('./lib-cov') :
    require('./lib');



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise-queue/index.js
// module id = 100
// module chunks = 0